module.exports = __webpack_public_path__ + "static/img/refinery_256.13b6a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refinery_256.png
// module id = tXn9
// module chunks = 0